module.exports = __webpack_public_path__ + "static/media/whiteTick.11e3c045.png";